import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/components/wysiwyg.js";
import "#legacy/admin/components/thumbnail_editor.js";
import "#legacy/admin/assessment_builder/views/base.js";
import "#legacy/admin/assessment_builder/views/mixins/thumbnail_editor.js";
import "./question.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.QuestionForm = class QuestionForm extends (
  AssessmentBuilder.Views.Mixins.ThumbnailEditor(AssessmentBuilder.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.renderResponses = this.renderResponses.bind(this);
    this.buildResponses = this.buildResponses.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    let responses = this.model.get("responses");
    if (!responses.length) {
      responses = this.buildResponses(2);
    }

    this.selectOneResponseFields = new AssessmentBuilder.Views.ResponseFormChoices({
      collection: responses,
      selectItems: this.selectItems,
      sortable: true,
      newResponseAttributes: { question: this.model },
    }).render();
    this.selectMultipleResponseFields = new AssessmentBuilder.Views.ResponseFormChoices({
      collection: responses,
      selectItems: this.selectItems,
      sortable: true,
      newResponseAttributes: { question: this.model },
    }).render();
    this.freeTextResponseFields = new AssessmentBuilder.Views.ResponseFormFreeText({
      model: responses.at(0),
      selectItems: this.selectItems,
    }).render();

    // BEHAVIOUR

    return this.listenTo(this.model, "change:responseType", this.renderResponses);
  }

  // RENDERING

  render() {
    this.$el.html(
      this.template(this.selectTemplateContext(this.model.attributes, { responseTypeItems: "response_type" })),
    );
    super.render(...arguments);
    Sparkle.Components.Wysiwyg.attach(this.$('textarea[name="instructions"]'), { toolset: "extended" });
    this.renderResponses();

    return this;
  }

  renderResponses() {
    jQuery(this.currentResponses).detach(); // Retain observers
    const allowExplanationInput = this.$('[name="allow_explanation"]');

    switch (this.model.get("responseType")) {
      case "select_one":
        this.currentResponses = this.selectOneResponseFields.render().el;
        allowExplanationInput.attr({ disabled: false });
        break;
      case "select_multiple":
        this.currentResponses = this.selectMultipleResponseFields.render().el;
        allowExplanationInput.attr({ disabled: false });
        break;
      case "free_text":
        this.currentResponses = this.freeTextResponseFields.render().el;
        allowExplanationInput.attr({ disabled: true }).prop({ checked: false }); // Free text is already a plac efor an explanation
        break;
    }

    return this.$(".response-container").append(this.currentResponses);
  }

  // HELPER FUNCTIONS

  buildResponses(count) {
    const responses = this.model.get("responses");
    while (count--) {
      responses.add(new AssessmentBuilder.Models.Response());
    }
    return responses;
  }
};
AssessmentBuilder.Views.QuestionForm.prototype.tagName = "question-form";
AssessmentBuilder.Views.QuestionForm.prototype.className = "assessment-form --view-question";
AssessmentBuilder.Views.QuestionForm.prototype.template = _.template(AssessmentBuilder.Templates.Question.form);
AssessmentBuilder.Views.QuestionForm.prototype.editorTriggerElementSelector =
  '[data-assessment-builder-behaviour~="question-thumbnail-editor"]';

AssessmentBuilder.Views.QuestionForm.prototype.events = {
  "input input[name=title]": "handleAttributeChange", // The navigator show question titles, so update in real time
  "change sp-select[name=response_type]": "handleAttributeChange", // The navigator show question titles, so update in real time
  "change :input[group=question], sp-select[group=question]": "handleAttributeChange",
};
